<template>
		
<FormulateForm
	v-if="!loading"
	ref="form"
	v-model="form"
	@submit="save" 
	>
	
	<FormulateInput
		label="Nombre"
		name="name"
		validation-name="Nombre"
		validation="required"
	/>
	
	<FormulateInput
		label="Apellido"
		name="lastname"
		validation-name="Apellido"
		validation="required"
	/>

	<FormulateInput
		type="identification"
		label="Documento de identidad"
		name="document"
		validation-name="Documento de identidad"
		validation="optional|^documentID"
	/>

	
	
	<div class="d-flex justify-content-between mt-4">
		<FormulateInput type="button" data-ghost @click="$emit('close')" >Cancelar</FormulateInput>
		<FormulateInput type="button" disabled v-if="saving">Guardando <span class="loader" /></FormulateInput>
		<FormulateInput type="submit" :label="title" v-else />
	</div>

</FormulateForm>

</template>

<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import formMixins from '@/mixins/formMixins'

export default {
	name: 'PharmacyDispenserForm',
	mixins: [mixins, formMixins],
	props:['id'],
	data () {
		return {
			title: 'Crear usuario dispensador',
			action: 'create',
			loading: true,
			saving: false,
			form:{
				name: null,
				lastname: null,
				document:{
					type: 'UY', number: null
				},
			},
		}
	},

	async beforeMount(){
		if(this.id){
			this.title = `Editar usuario dispensador`
			this.action = 'update'
			await this.load()
		}
		this.loading = false
	},
	methods:{
		save(){
			if(!this.saving){
				this.saving = true
				let dataInput = {
					name: this.form.name,
					lastname: this.form.lastname,
					document: this.form.document,
				}
				
				if(this.action =='create'){
					this.create(dataInput)
				}
				if(this.action =='update'){
					this.update(dataInput)
				}
			}
		},


		create(data){
			this.$apollo.mutate({
				mutation: gql`mutation ( $data:PharmacyDispenserInput! ){
					pharmacyDispenserCreate( data: $data) {
						id
						name
					}
				}`,
				variables: {
					data
				}
			})
			.then(({data}) => {
				this.$toast.success('Usuario creado correctamente')
				this.$emit('created', data.pharmacyDispenserCreate)
				this.saving = false
			})
			.catch( (error) => {
				this.parseGQLErrors(error)
				this.saving = false
			})
		},

		
		update(dataInput){
			this.$apollo.mutate({
				mutation: gql`mutation ( $id: ID!, $data:PharmacyDispenserInput! ){
					pharmacyDispenserUpdate( id: $id, data: $data) {
						id
						name
					}
				}`,
				variables: {
					id: this.id,
					data: dataInput
				}
			})
			.then(({data}) => {
				this.$toast.success('Usuario editado correctamente')
				this.$emit('updated', data.pharmacyDispenserUpdate)
				this.saving = false
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.saving = false
			})
		},

		load(){
			return this.$apollo.query({
				query: gql`query ($id: ID!) {
					pharmacyDispenser(id: $id) {
						id
						name
						lastname
						document{
							type
							number
						}
					}
				}`,
				variables: { id: this.id },
				fetchPolicy: 'network-only',
			})
			.then(({data}) => {
				this.form = {
					...this.$omitDeep(data.pharmacyDispenser, "__typename"),
				}
			})
			.catch(()=>{
				this.$toast.success('El item que desea editar no existe')
				// this.$router.go(-1)
			})
		},


	
	}
}


</script>

<style>

</style>
